import { render, staticRenderFns } from "./buyCart.vue?vue&type=template&id=1f3cc36e&scoped=true&"
import script from "./buyCart.vue?vue&type=script&lang=js&"
export * from "./buyCart.vue?vue&type=script&lang=js&"
import style0 from "./buyCart.vue?vue&type=style&index=0&id=1f3cc36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3cc36e",
  null
  
)

export default component.exports